export default {
  labels: {
    open: 'Mostra articoli',
    collapse: 'Chiudi articoli',
    in_stock: 'Disponibile',
    out_of_stock: 'Non disponibile',
  },
  list: {
    name: 'Voce del menu',
    price: 'Prezzo',
    is_available: 'DISPONIBILE/NON DISPONIBILE',
  },
};
